import React from 'react'
import "./My_rewards.css"
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Contribution from '../../../home/contribution/Contribution';
import My_rewards_user_card from './my_rewards_user_card/My_rewards_user_card';
import My_rewards_user_list from './my_rewards_user_list/My_rewards_user_list';

function My_rewards() {
    const breadcrumbData = [
        { label: "Rewards", path: "/rewards", active: false },
        { label: "My Rewards", active: true }
    ];
    return (
        <>
            <section className='My_rewards wallet_inner_banner_section'>
                <div className="container">
                    <Common_recharge_page_banner title="MY REWARDS" className="Upgraded_menu_banner" breadcrumbItems={breadcrumbData} />
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <My_rewards_user_card />
                            <My_rewards_user_list />
                        </div>
                    </div>
                    <Contribution />
                </div>
            </section>
        </>
    )
}

export default My_rewards